import { List, Create, Edit, AddUser, Assign, ViewUser, AddCompany } from "../Components/index.js";

export default [
    {
        path: "/admin/appointment",
        component: List,
        name: "appointment.list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/appointment/assign",
        component: Assign,
        name: "appointment.assign",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/appointment/:id/edit",
        component: Edit,
        name: "appointment.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/appointment/create",
        component: Create,
        name: "appointment.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/appointment/:id/add-user",
        component: AddUser,
        name: "appointment.add.user",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/appointment/:id/add-company",
        component: AddCompany,
        name: "appointment.add.company",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/appointment/:id/view-user",
        component: ViewUser,
        name: "appointment.view.user",
        meta: {
            requiresAuth: true,
        },
    },
];
